__turbopack_context__.v({
  "Banner": "PYI0jG_Banner",
  "Banner__Container": "PYI0jG_Banner__Container",
  "Banner__Text": "PYI0jG_Banner__Text",
});
